import ErrorLogDetails from '@/components/Logs/ErrorLogDetails';
import { PostbackErrorLogViewModel } from '@/viewModels/postbackErrorLog';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: { ErrorLogDetails }
})
export default class PostbackErrorLogs extends Vue {
  public viewModel = new PostbackErrorLogViewModel();
  public pagination: any = {};
  public status: number = 500;
  public get report() {
    return this.$store.getters.postbackErrorLogs;
  }
  public get isDialogOpen() {
    return this.$store.getters.dialogOpen;
  }
  public get busy() {
    return this.$store.getters.isBusy;
  }

  public search() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;

    this.$api.getPostBackErrorLogs(
      this.status,
      page > 0 ? page - 1 : page,
      rowsPerPage
    );
  }
  @Watch('pagination') onPageChanged(o, n) {
    this.search();
  }
  public truncate() {
    this.$api.truncatePostbackLogs();
  }
  mounted() {
    // this.command.ngbid = 5;
    this.search();
  }
  public viewDetails(model) {
    this.$api.setErrorLog(model);
    this.setDialogState(true);
  }

  public closeDialog() {
    this.$api.setErrorLog(undefined);
    this.setDialogState(false);
  }

  private setDialogState(isOpen: boolean) {
    this.$dataService.setDialogState(isOpen);
    this.$store.dispatch('setDialogState', isOpen);
  }
}
